// --- Our Modules --------------------------------------------------------------------------------
import "./styles.css";
// --- Logic --------------------------------------------------------------------------------------
type Props = { label: string; tone?: "gold" | "quiet" };

/** A small read-only chip. It reports a value and is never a control — see the ui-design rule. */
export default function Badge({ label, tone = "quiet" }: Props) {
    return <span className={`badge badge--${tone}`}>{label}</span>;
}
